import { isPlatformServer } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@client';
import { TOKEN_KEY } from '@common';
import { catchError, throwError } from 'rxjs';

export const HttpInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const router = inject(Router);

  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) {
    return next(req);
  }

  const accessToken = localStorage.getItem(TOKEN_KEY.ADMIN_ACCESS_TOKEN_KEY);

  const request = req.clone({
    setHeaders: {
      authorization: `Bearer ${accessToken}`,
    },
    withCredentials: true,
  });

  return next(request).pipe(
    catchError((error) => {
      if (error.status === 401) {
        localStorage.removeItem(TOKEN_KEY.ADMIN_ACCESS_TOKEN_KEY);
        localStorage.removeItem(TOKEN_KEY.ADMIN_REFRESH_TOKEN_KEY);
        router.navigateByUrl('/login', { replaceUrl: true });
      }

      if (error.status === 498) {
        localStorage.removeItem(TOKEN_KEY.ADMIN_ACCESS_TOKEN_KEY);
        localStorage.removeItem(TOKEN_KEY.ADMIN_REFRESH_TOKEN_KEY);
        router.navigateByUrl('/login', { replaceUrl: true });
      }
      if (!error.error.message) {
        toast.error(JSON.parse(error.error).message);
        return Promise.reject(error);
      }

      toast.error(error.error.message);
      return Promise.reject(error);
    }),
  );
};
